/** @jsx jsx */
import { jsx } from "theme-ui"
import { Link } from "gatsby"
import { OutboundLink } from "gatsby-plugin-google-analytics"

export default ({
  children,
  bg = "darkPurple",
  color = "white",
  to,
  external = false,
  styles,
}) =>
  !external ? (
    <Link
      sx={{
        variant: "buttons.primary",
        color,
        bg,
        textDecoration: "none",
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        "&:hover": {
          bg: "purple",
          color: "white",
        },
        ...styles,
      }}
      to={to}
    >
      {children}
    </Link>
  ) : (
    <OutboundLink
      sx={{
        variant: "buttons.primary",
        color,
        bg,
        textDecoration: "none",
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        "&:hover": {
          bg: "purple",
          color: "white",
        },
        ...styles,
      }}
      href={to}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </OutboundLink>
  )
